<a href="#main-content" class="skip-link">Saltar al contenido</a>
<header class="app-shell-header">
  <div class="header-left">
    <button
      type="button"
      class="menu-toggle-btn"
      (click)="toggleSidebar()"
      [attr.aria-expanded]="sidebarOpen"
      aria-controls="app-shell-nav"
      [attr.aria-label]="sidebarOpen ? 'Cerrar menú de navegación' : 'Abrir menú de navegación'">
      <i class="fas" [ngClass]="sidebarOpen ? 'fa-times' : 'fa-bars'" aria-hidden="true"></i>
    </button>
    <div class="header-brand-wrap">
      <a routerLink="/firmar" class="header-brand-logo" [attr.aria-label]="brand.PRODUCT_NAME_WEB">
        <span class="header-brand-product" aria-hidden="true">{{ brand.PRODUCT_NAME_WEB }}</span>
      </a>
    </div>
  </div>
  <div class="header-right">
    <button
      type="button"
      class="header-tour-btn"
      (click)="openContextualTour()"
      [attr.aria-label]="tourButtonLabel"
      [title]="tourButtonLabel">
      <i class="fas fa-route" aria-hidden="true"></i>
      <span>Guía</span>
    </button>
    <a [href]="certicamaraUrl" target="_blank" rel="noopener" class="certicamara-brand" title="Certicámara">
      <span class="cc-icon"><i class="fas fa-building" aria-hidden="true"></i></span>
      <span>Página web de Certicámara</span>
    </a>
    <span class="app-version-chip" aria-label="Versión del sistema">v{{ appVersion }}</span>
    <a [href]="canalVentasUrl" target="_blank" rel="noopener" class="canal-ventas-btn" title="Ir al canal de ventas">
      <i class="fas fa-store" aria-hidden="true"></i>
      <span>Compra tu firma aquí</span>
    </a>
  </div>
</header>

<div class="drawer-overlay" (click)="closeSidebar()" [attr.aria-hidden]="!sidebarOpen" role="presentation"></div>

<div class="app-shell-main">
  <aside
    class="app-shell-sidebar"
    id="app-shell-nav"
    [attr.aria-hidden]="mobileDrawerMode ? !sidebarOpen : null">
    <div class="sidebar-panel">
      <div class="sidebar-drawer-top">
        <span class="sidebar-drawer-top-label">Menú</span>
        <button
          type="button"
          class="sidebar-drawer-close"
          (click)="closeSidebar()"
          aria-label="Cerrar menú de navegación">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <!-- Firmar y verificar -->
      <div class="sidebar-section">
        <div class="sidebar-section-title">Firmar y verificar</div>
        <button
          type="button"
          id="tour-target-firmar-menu"
          class="sidebar-item-expandible firmar-verificar-btn"
          [class.active]="isFirmarRoute || isVerifyRoute"
          [attr.aria-expanded]="firmarVerificarMenuOpen"
          aria-controls="firmar-verificar-list"
          (click)="toggleFirmarVerificar()"
          aria-label="Firmar y verificar. Mecanismos y verificación">
          <span class="icon-wrap icon-firmar-verificar"><i class="fas fa-pen-nib" aria-hidden="true"></i></span>
          <span class="mec-label">
            <span class="label">Firmar y verificar</span>
            <span class="desc">Mecanismos y verificación</span>
          </span>
          <span class="chevron" aria-hidden="true"><i class="fas fa-chevron-down"></i></span>
        </button>
        <div
          class="firmar-verificar-list"
          id="firmar-verificar-list"
          [hidden]="!firmarVerificarMenuOpen"
          role="region"
          aria-label="Opciones de firmar y verificar">
          <ng-container *ngFor="let m of mechanisms">
            <button
              type="button"
              class="mecanismo-item"
              [ngClass]="m.iconWrapClass"
              [class.selected]="isFirmarRoute && currentMechanism === m.id"
              (click)="selectMechanism(m.id)"
              [attr.aria-pressed]="isFirmarRoute && currentMechanism === m.id"
              [attr.aria-label]="m.label + ': ' + m.desc">
              <span class="icon-wrap" [ngClass]="m.iconWrapClass">
                <i [class]="m.iconClass" aria-hidden="true"></i>
              </span>
              <span class="mec-label">
                <span class="label">{{ m.label }}</span>
                <span class="desc">{{ m.desc }}</span>
              </span>
            </button>
          </ng-container>
          <button
            type="button"
            id="tour-target-verificar"
            class="verificar-item"
            [class.disabled-item]="disableVerifyInPhaseOne"
            [class.active]="isVerifyRoute"
            (click)="goToVerificar()"
            [disabled]="disableVerifyInPhaseOne"
            [attr.aria-pressed]="isVerifyRoute"
            [attr.aria-disabled]="disableVerifyInPhaseOne"
            aria-label="Verificar firmas">
            <span class="icon-wrap icon-firmar-verificar"><i class="fas fa-certificate" aria-hidden="true"></i></span>
            <span class="mec-label">
              <span class="label">Verificar firmas</span>
              <span class="desc">{{ certifirmaDesc.VERIFY }}</span>
            </span>
          </button>
        </div>
      </div>

      <!-- Administración -->
      <div class="sidebar-section">
        <div class="sidebar-section-title section-spacer">Administración</div>
        <button
          type="button"
          class="sidebar-item-expandible admin-btn"
          [class.active]="isAnyAdminRoute"
          [attr.aria-expanded]="adminMenuOpen"
          aria-controls="admin-sub"
          (click)="toggleAdmin()"
          aria-label="Administración por tipo de certificado">
          <span class="icon-wrap icon-admin"><i class="fas fa-gear" aria-hidden="true"></i></span>
          <span class="mec-label">
            <span class="label">Administración</span>
            <span class="desc">Por tipo</span>
          </span>
          <span class="chevron" aria-hidden="true"><i class="fas fa-chevron-down"></i></span>
        </button>
        <ul class="admin-sub" id="admin-sub" [hidden]="!adminMenuOpen" role="region" aria-label="Opciones de administración">
          <li>
            <button
              type="button"
              id="tour-target-admin-rse"
              class="sidebar-sub-item"
              [class.disabled-item]="!adminTokenVirtualRseEnabled"
              [class.active]="isAdminTokenVirtualRseRoute"
              (click)="goToAdministrarTokenVirtualRse()"
              [disabled]="!adminTokenVirtualRseEnabled"
              [attr.aria-pressed]="isAdminTokenVirtualRseRoute"
              [attr.aria-disabled]="!adminTokenVirtualRseEnabled"
              [attr.aria-label]="'Administrar ' + certifirma.VIRTUAL_OTP">
              <span class="icon-wrap icon-admin-rse"><i class="fas fa-shield-halved" aria-hidden="true"></i></span>
              <span class="mec-label">
                <span class="label">{{ certifirma.VIRTUAL_OTP }}</span>
                <span class="desc">{{ certifirmaDesc.ADMIN_VIRTUAL_OTP }}</span>
              </span>
            </button>
          </li>
          <li>
            <button
              type="button"
              id="tour-target-admin-tv"
              class="sidebar-sub-item"
              [class.disabled-item]="!adminTokenVirtualEnabled"
              [class.active]="isAdminTokenVirtualRoute"
              (click)="goToAdministrarTokenVirtual()"
              [disabled]="!adminTokenVirtualEnabled"
              [attr.aria-pressed]="isAdminTokenVirtualRoute"
              [attr.aria-disabled]="!adminTokenVirtualEnabled"
              [attr.aria-label]="'Administrar ' + certifirma.VIRTUAL">
              <span class="icon-wrap icon-admin-tv"><i class="fas fa-cloud" aria-hidden="true"></i></span>
              <span class="mec-label">
                <span class="label">{{ certifirma.VIRTUAL }}</span>
                <span class="desc">{{ certifirmaDesc.ADMIN_VIRTUAL }}</span>
              </span>
            </button>
          </li>
          <li>
            <button
              type="button"
              id="tour-target-admin-p10"
              class="sidebar-sub-item"
              [class.disabled-item]="!adminP10Enabled"
              [class.active]="isAdminP10Route"
              (click)="goToAdministrarP10()"
              [disabled]="!adminP10Enabled"
              [attr.aria-pressed]="isAdminP10Route"
              [attr.aria-disabled]="!adminP10Enabled"
              [attr.aria-label]="'Administrar ' + certifirma.PKCS10">
              <span class="icon-wrap icon-admin-p10"><i class="fas fa-file-lines" aria-hidden="true"></i></span>
              <span class="mec-label">
                <span class="label">{{ certifirma.PKCS10 }}</span>
                <span class="desc">{{ certifirmaDesc.ADMIN_PKCS10 }}</span>
              </span>
            </button>
          </li>
          <li *ngIf="tokenFisicoEnabled && agentAvailable">
            <button
              type="button"
              id="tour-target-admin-tf"
              class="sidebar-sub-item"
              [class.active]="isAdminTokenFisicoRoute"
              (click)="goToAdministrarTokenFisico()"
              [attr.aria-pressed]="isAdminTokenFisicoRoute"
              [attr.aria-label]="'Administrar ' + certifirma.FISICO">
              <span class="icon-wrap icon-token-fisico"><i class="fas fa-usb" aria-hidden="true"></i></span>
              <span class="mec-label">
                <span class="label">{{ certifirma.FISICO }}</span>
                <span class="desc">{{ certifirmaDesc.ADMIN_FISICO }}</span>
              </span>
            </button>
          </li>
          <li *ngIf="tokenFisicoEnabled && agentAvailable">
            <button
              type="button"
              id="tour-target-admin-tf-descargar"
              class="sidebar-sub-item"
              [class.active]="isDescargarCertificadoRoute"
              (click)="goToDescargarCertificado()"
              [attr.aria-pressed]="isDescargarCertificadoRoute"
              aria-label="Descargar certificado al Certifirma Digital Físico">
              <span class="icon-wrap icon-token-fisico"><i class="fas fa-download" aria-hidden="true"></i></span>
              <span class="mec-label">
                <span class="label">Descargar al token</span>
                <span class="desc">Solicitud e importar PFX</span>
              </span>
            </button>
          </li>
        </ul>
      </div>

      <!-- Gestión (postventa): oculto temporalmente con showGestionMenu — poner true para reactivar -->
      <div class="sidebar-section" *ngIf="showGestionMenu">
        <div class="sidebar-section-title section-spacer">Gestión</div>
        <button
          type="button"
          class="sidebar-item-expandible admin-btn"
          [class.active]="isAnyGestionRoute"
          [attr.aria-expanded]="gestionMenuOpen"
          aria-controls="gestion-sub"
          (click)="toggleGestion()"
          aria-label="Gestión de servicios postventa">
          <span class="icon-wrap icon-gestion"><i class="fas fa-briefcase" aria-hidden="true"></i></span>
          <span class="mec-label">
            <span class="label">Gestión</span>
            <span class="desc">Postventa</span>
          </span>
          <span class="chevron" aria-hidden="true"><i class="fas fa-chevron-down"></i></span>
        </button>
        <ul class="admin-sub" id="gestion-sub" [hidden]="!gestionMenuOpen" role="region" aria-label="Opciones de gestión">
          <li>
            <button
              type="button"
              class="sidebar-sub-item"
              [class.active]="isGestionEstadoRoute"
              (click)="goToGestion('estado-tramite')"
              [attr.aria-pressed]="isGestionEstadoRoute"
              aria-label="Consultar estado del trámite">
              <span class="icon-wrap icon-gestion-estado"><i class="fas fa-clipboard-list" aria-hidden="true"></i></span>
              <span class="mec-label">
                <span class="label">Estado del trámite</span>
                <span class="desc">Consultar solicitud</span>
              </span>
            </button>
          </li>
          <li>
            <button
              type="button"
              class="sidebar-sub-item"
              [class.active]="isGestionFacturaRoute"
              (click)="goToGestion('factura')"
              [attr.aria-pressed]="isGestionFacturaRoute"
              aria-label="Descargar factura">
              <span class="icon-wrap icon-gestion-factura"><i class="fas fa-file-invoice" aria-hidden="true"></i></span>
              <span class="mec-label">
                <span class="label">Descargar factura</span>
                <span class="desc">Obtener PDF</span>
              </span>
            </button>
          </li>
          <li>
            <button
              type="button"
              class="sidebar-sub-item"
              [class.active]="isGestionRevocarRoute"
              (click)="goToGestion('revocar')"
              [attr.aria-pressed]="isGestionRevocarRoute"
              aria-label="Revocar certificado">
              <span class="icon-wrap icon-gestion-revocar"><i class="fas fa-ban" aria-hidden="true"></i></span>
              <span class="mec-label">
                <span class="label">Revocar certificado</span>
                <span class="desc">Anular vigencia</span>
              </span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </aside>
  <div class="app-shell-content" id="main-content" tabindex="-1">
    <router-outlet></router-outlet>
  </div>
</div>

<footer class="app-shell-footer">
  © {{ currentYear }} {{ brand.PRODUCT_NAME_WEB }} · {{ brand.ENDORSEMENT }} · v{{ appVersion }}
</footer>

<app-tour></app-tour>
